export const table_titles = [
	{ name: "#", size: 3, order: "" },
	{ name: "RUT", size: 10, order: "rut_dealer" },
	{ name: "Nombre Corto", size: 10, order: "common_name" },
	{ name: "Nombre", size: 10, order: "name" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_dealer = {
	dealer_id: "",
	rut_dealer: "",
	common_name: "",
	name: "",
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
